module.exports = __webpack_public_path__ + "static/media/module-program-card-banner-general-fitness@2x.8256803b.png";